<template>
		<ul class="izk-course-list" v-if="coursesList.length > 0">
			<div v-for="item in coursesList">
				<OneCommon v-if="!item.is_experience && !item.is_picture && item.card_type == 1" :course="item" @order="order"></OneCommon>
				<OneExperience v-if='item.is_experience' :course="item" @order="order"></OneExperience>
				<OnePicture v-if="item.is_picture" :course="item" @order="order" @goDetail="goDetail" ></OnePicture>
				<QqIntro v-if="item.card_type == 2" :qqIntro="item" :name="'面熟1对1'"></QqIntro>
			</div>
        </ul>
</template>
<script>
	import OneCommon from '@/components/courseCenter/one/public/Common.vue';
	import OnePicture from '@/components/courseCenter/one/public/Picture.vue';
	import OneExperience from '@/components/courseCenter/one/public/Experience.vue';
	import QqIntro from '@/components/courseCenter/public/qq/Qq.vue';
import {mapState} from 'vuex';
import utils from '../../../../common/libs/utils.js';

	export default{
	  name: 'Manage',
	  components: {
	    OneCommon,
	    OnePicture,
	    OneExperience,
	    QqIntro
	  },
	  props: {
	    coursesList: {
	      type: Array,
	      default: [{
	        school_info: {}
	      }],
	      required: true
	    }
	  },
  computed: mapState({
    city: state => state.home.city
  }),
	  data(){
	    return {

	    }
	  },
	  methods: {
	    order(course){
      let route = this.$route;
      let stater = this.$store.state;
      let obj = {
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'class_type': '面授课1对1',
        'course_type': course.extra_type_3 || '',
        'course_grade': course.grade_msg || '',
        'course_subject': course.subject_msg || '',
        'course_cycle_time': course.course_begin_datetime,
        'course_location': course.school_info.address,
        'course_character': course.extra_type_3,
        'course_name': course.title
      }

      utils.bury('yd_izhikang_courselist_order_click', obj);

      if (course.sub_status){

        this.$router.push({
          path: `/${  route.params.city  }/detail/${  course.course_id}`,
          query: {
            grade: course.grade,
            type: course.type,
            sub_type: course.sub_type,
            school_id: course.school_id,
            lat: this.city.lat || '',
            lng: this.city.lng || '',
            category: "10001",
            course_type: 102,
            routeName: 'faceToface'
          }
        })

        return;
      }
      this.$router.push({name: 'order', query: {
        course_id: course.course_id,
        grade: course.grade,
        type: course.type,
        sub_type: course.sub_type,
        course_type: 102,
        school_id: course.school_info.id,
        school_name: course.school_info.name,
        address: course.school_info.address,
        lat: this.city.lat || '',
        lng: this.city.lng || '',
        name: 'faceToface',
        category: '10001',
        teaching_mode: '1001'
      }})
    },
    goDetail(course){
      let route = this.$route;

      this.$router.push({
        path: `/${  route.params.city  }/detail/${  course.course_id}`,
        query: {
          grade: course.grade,
          type: course.type,
          sub_type: course.sub_type,
          school_id: course.school_id,
          lat: this.city.lat || '',
          lng: this.city.lng || '',
          category: "10001",
          course_type: 102,
          routeName: 'faceToface'
        }
      })
    }
	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/one/public/Manage.vue